module.exports = __webpack_public_path__ + "img/conf_tems.1106c266.png";